module.exports = __webpack_public_path__ + "static/media/weather-app-image.0bc38f2a.png";